<template>
	<div class="pos" style="padding-bottom: 100px;">
		<div class="p20">
			<div class="page_title">项目列表</div>
		</div>
		<div class="bgfff pt20 plr20" v-for="(item, index) in list" :key="index" @click="
          $router.push({ path: '/mListDetail', query: { id: item.id,name:item.name} })
        ">
			<div class="pb20 bor_b">{{item.name}}</div>
			<!-- <div class="bor_b pb20">名称{{index}}</div> -->
		</div>
		<div class="empty" v-if="list.length == 0">暂无数据</div>
		<div class="right-circle" @click="$router.push('/addpro')">新建</div>
	</div>
</template>
<script>
	import {
		List
	} from "vant";
	export default {
		components: {
			List,
		},
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
			};
		},
		created() {
			// this.list = 20
			this.getList()
		},
		methods: {
			getList() {
				this.api.projectList().then(res => {
					this.list = res.data
				})
			},
		},
	};
</script>

<style scoped>
	.bottom_btn {
		bottom: 100px;
	}
</style>
